import { SubscribtionConfirmComponent as SubscribtionConfirmComponentCore } from './../../../SubscriptionConfirm/SubscribtionConfirm.component';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-subscribtion-confirm',
    templateUrl: './subscription-confirm.component.html',
    styleUrls: ['./subscription-confirm.component.css']
})
export class SubscribtionConfirmComponent extends SubscribtionConfirmComponentCore {

}
